import { useEffect } from 'react';
import './finalizaCadastroToken.scss';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { yupResolver } from '@hookform/resolvers/yup';
import { formSchemaCadastroToken } from './FormSchema';
import { useForm } from 'react-hook-form';
import { useLocation } from 'react-router-dom';
import { ENVIAR_TOKEN, ATIVAR_IDCORREIOS } from '../../../services/cadastro';
import useFetch from '../../../components/hooks/useFetch';
import InputToken from '../../../components/form/InputToken';
import { abreAlertaDialog } from '../../../components/modal/AlertaDialog';

const FinalizaCadastroToken = () => {
  const { t } = useTranslation();
  const methods = useForm({ resolver: yupResolver(formSchemaCadastroToken) });
  const location = useLocation();
  const meioEnvio = location.state?.meioEnvio;
  const meioEnvioEmail = location.state?.meioEnvioEmail;
  const meioEnvioTelefone = location.state?.meioEnvioTelefone;
  const meioEnvioDDD = location.state?.meioEnvioDDD;
  const idCorreios = location.state?.idCorreios;
  const { request } = useFetch();

  const formMethods = {
    inputRef: methods.register,
    errors: methods.errors,
    control: methods.control,
    watch: methods.watch,
  };

  const navigate = useNavigate();
  var campoMostrar;
  var tipoMeioEnvio;
  if (meioEnvio === 'C') {
    campoMostrar = '*****' + meioEnvioTelefone?.slice(-4);
    tipoMeioEnvio = t('cadastro.forms.options.mobile_option');
  } else {
    campoMostrar =
      '***' +
      meioEnvioEmail?.substring(0, 4) +
      '***' +
      meioEnvioEmail?.slice(-6);
    tipoMeioEnvio = t('cadastro.forms.options.email_option');
  }
  const reenviaToken = async () => {
    var token;
    //if (meioEnvio === 'C') {
    token = {
      meioEnvio: meioEnvio,
      funcionalidade: 'CADASTRO_USUARIO',
      // telefone: meioEnvioDDD + meioEnvioTelefone,
    };
    /*} else {
      token = {
        meioEnvio: meioEnvio,
        funcionalidade: 'CADASTRO_USUARIO',
        email: meioEnvioEmail,
      }; 
    }*/
    const { response } = await request(ENVIAR_TOKEN(idCorreios, token));
    if (response.ok) {
      abreAlertaDialog(t('cadastro.messages.success.token_sent'));
    }
    const form = document.getElementById('formToken');
    const campos = form.querySelectorAll('input');
    campos.forEach((campo) => {
      campo.value = '';
    });
  };

  const alterar = async () => {
    if (
      !document.getElementById('confirmarSenha1').value ||
      !document.getElementById('confirmarSenha2').value ||
      !document.getElementById('confirmarSenha3').value ||
      !document.getElementById('confirmarSenha4').value ||
      !document.getElementById('confirmarSenha5').value ||
      !document.getElementById('confirmarSenha6').value
    ) {
      abreAlertaDialog(t('cadastro.messages.validation.token_required'));
    } else {
      const dadosEnviar = {
        idCorreios,
        code:
          document.getElementById('confirmarSenha1').value +
          document.getElementById('confirmarSenha2').value +
          document.getElementById('confirmarSenha3').value +
          document.getElementById('confirmarSenha4').value +
          document.getElementById('confirmarSenha5').value +
          document.getElementById('confirmarSenha6').value,
      };
      const { response } = await request(ATIVAR_IDCORREIOS(dadosEnviar));
      if (response.ok) {
        navigate('/cadastroFinalizado');
      }
    }
  };

  return (
    <>
      <div id="finaliza-cadastro" className="conteudo">
        <div id="bem-vindo" className="card bg-superficie elev5">
          <img
            alt="Imagem de perfil da Carol"
            id="img-carol-boasvindas"
            src="/images/carol-perfil.png"
          />

          <h2>{t('cadastro.titles.finalize')}</h2>

          <p className="txt-finalizacao">
            {t('cadastro.messages.info.token_instructions', { method: tipoMeioEnvio + ' ' + campoMostrar })}
          </p>
          <form id="formToken">
            <div className="campo-txt">
              <InputToken {...formMethods} />
              <div className="mensagem legenda"></div>
            </div>

            <div className="btns-row">
              <button
                id="btn-voltar"
                type="button"
                className="btn-txt"
                onClick={() => navigate('/login')}
              >
                {t('cadastro.forms.buttons.back')}
              </button>

              <button
                id="btn-reenviar"
                type="button"
                className="btn-cont"
                onClick={reenviaToken}
              >
                {t('cadastro.forms.buttons.resend_code')}
              </button>

              <button
                id="btn-finalizar"
                type="button"
                className="btn-pre"
                onClick={alterar}
              >
                {t('cadastro.forms.buttons.complete')}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};
export default FinalizaCadastroToken;
